import { Link } from "@tanstack/react-router";
import { Clock, ArrowUpRight } from "lucide-react";

export interface BlogCardPost {
  slug: string;
  title: string;
  excerpt: string | null;
  cover_url_card: string | null;
  cover_focal_x: number;
  cover_focal_y: number;
  category: { name: string; color: string; slug: string } | null;
  reading_minutes: number;
  published_at: string | null;
  author_name: string | null;
}

export function BlogPostCard({ post, compact }: { post: BlogCardPost; compact?: boolean }) {
  return (
    <Link
      to="/blog/$slug"
      params={{ slug: post.slug }}
      className="group flex flex-col rounded-2xl bg-white border border-border overflow-hidden hover:shadow-lg hover:-translate-y-0.5 transition"
    >
      <div className={`relative overflow-hidden ${compact ? "aspect-[16/9]" : "aspect-[16/10]"} bg-slate-100`}>
        {post.cover_url_card ? (
          <img
            src={post.cover_url_card}
            alt={post.title}
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            style={{ objectPosition: `${post.cover_focal_x * 100}% ${post.cover_focal_y * 100}%` }}
          />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center text-slate-300 text-4xl font-black">FIXHEN</div>
        )}
        {post.category ? (
          <span
            className="absolute left-3 top-3 rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-white shadow-md"
            style={{ background: post.category.color }}
          >
            {post.category.name}
          </span>
        ) : null}
      </div>
      <div className="flex flex-col flex-1 p-4 gap-2">
        <h3 className="text-lg font-extrabold text-ink group-hover:text-[#172554] transition line-clamp-2 leading-tight">
          {post.title}
        </h3>
        {post.excerpt ? <p className="text-sm text-slate-500 line-clamp-2 leading-snug">{post.excerpt}</p> : null}
        <div className="mt-auto flex items-center gap-2 text-[11px] text-slate-500 pt-2 border-t border-slate-100">
          <span>{post.author_name ?? "FIXHEN"}</span>
          <span>·</span>
          <span>
            {post.published_at
              ? new Date(post.published_at).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
              : ""}
          </span>
          <span>·</span>
          <span className="inline-flex items-center gap-0.5">
            <Clock className="h-3 w-3" /> {post.reading_minutes} min
          </span>
          <ArrowUpRight className="ml-auto h-3.5 w-3.5 text-slate-400 group-hover:text-[#172554] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition" />
        </div>
      </div>
    </Link>
  );
}